import { render, staticRenderFns } from "./detailBaseItem.vue?vue&type=template&id=75dfa0f9&scoped=true&"
import script from "./detailBaseItem.vue?vue&type=script&lang=js&"
export * from "./detailBaseItem.vue?vue&type=script&lang=js&"
import style0 from "./detailBaseItem.vue?vue&type=style&index=0&id=75dfa0f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dfa0f9",
  null
  
)

export default component.exports